import * as t from "io-ts";

export enum CryptoCurrency {
  AAVE = "AAVE",
  ALCX = "ALCX",
  ALGO = "ALGO",
  // ALI = "ALI",
  AMP = "AMP",
  ANKR = "ANKR",
  APE = "APE",
  API3 = "API3",
  AUDIO = "AUDIO",
  AVAX = "AVAX",
  AXS = "AXS",
  BAT = "BAT",
  BCH = "BCH",
  BNB = "BNB",
  BNT = "BNT",
  BOME = "BOME",
  BOND = "BOND",
  BONK = "BONK",
  BTC = "BTC",
  CHILLGUY = "CHILLGUY",
  CHZ = "CHZ",
  COMP = "COMP",
  CRV = "CRV",
  CTX = "CTX",
  CUBE = "CUBE",
  CVC = "CVC",
  DAI = "DAI",
  DOGE = "DOGE",
  DOT = "DOT",
  ELON = "ELON",
  ENS = "ENS",
  ETH = "ETH",
  FARTCOIN = "FARTCOIN",
  FET = "FET",
  FIL = "FIL",
  FLOKI = "FLOKI",
  FTM = "FTM",
  GAL = "GAL",
  GALA = "GALA",
  GMT = "GMT",
  GOAT = "GOAT",
  GRT = "GRT",
  GUSD = "GUSD",
  HNT = "HNT",
  IMX = "IMX",
  INJ = "INJ",
  IOTX = "IOTX",
  JAM = "JAM",
  KNC = "KNC",
  KP3R = "KP3R",
  LDO = "LDO",
  LINK = "LINK",
  LPT = "LPT",
  LRC = "LRC",
  LTC = "LTC",
  MANA = "MANA",
  MASK = "MASK",
  MATIC = "MATIC",
  MCO2 = "MCO2",
  MEW = "MEW",
  MKR = "MKR",
  MNT = "MNT",
  MOB = "MOB",
  MOODENG = "MOODENG",
  NMR = "NMR",
  OP = "OP",
  OXT = "OXT",
  PAXG = "PAXG",
  PEPE = "PEPE",
  PNUT = "PNUT",
  POL = "POL",
  POPCAT = "POPCAT",
  PYTH = "PYTH",
  QNT = "QNT",
  QRDO = "QRDO",
  RARE = "RARE",
  RAY = "RAY",
  REN = "REN",
  RLUSD = "RLUSD",
  RNDR = "RNDR",
  SAMO = "SAMO",
  SAND = "SAND",
  SBR = "SBR",
  SHIB = "SHIB",
  SKL = "SKL",
  SLP = "SLP",
  SNX = "SNX",
  SOL = "SOL",
  STORJ = "STORJ",
  SUSHI = "SUSHI",
  UMA = "UMA",
  UNI = "UNI",
  USDC = "USDC",
  USDT = "USDT",
  WIF = "WIF",
  XLM = "XLM",
  XRP = "XRP",
  XTZ = "XTZ",
  YFI = "YFI",
  ZBC = "ZBC",
  ZEC = "ZEC",
  ZRX = "ZRX",
}

export enum ContractType {
  ERC20 = "ERC-20",
  SPL = "SPL",
}

export const cryptoAddressCodec = t.intersection([
  t.type({
    name: t.string,
    symbol: t.string,
    address: t.string,
  }),
  t.partial({
    network: t.union([t.string, t.undefined]),
    tagMemo: t.union([t.string, t.undefined]),
  }),
]);

export const cryptoAddressesCodec = t.array(cryptoAddressCodec);

export type CryptoAddressResponse = t.TypeOf<typeof cryptoAddressCodec>;
